import parsePhoneNumber, { AsYouType, formatIncompletePhoneNumber } from 'libphonenumber-js';

export const getPhoneNumberParts = (
  phoneNumber: string,
  codesList: string[]
): [string | undefined, string] => {
  if (!phoneNumber.startsWith('+') || phoneNumber.startsWith('+0')) return [undefined, phoneNumber];
  const countryCode = codesList.find(code => phoneNumber.startsWith(code));
  const subscriberNumber = phoneNumber.substring(countryCode?.length || 0);
  return [countryCode, subscriberNumber];
};

export const cleanSubscriberNumber = (phoneNumber: string) => {
  return phoneNumber.replace(/\D/g, '');
};

export const getCountry = (countryCode: string, number: string) => {
  const asYouTypeCode = new AsYouType();
  asYouTypeCode.input(countryCode + number);
  return countryCode === '+1' ? 'US' : asYouTypeCode.getNumber()?.country;
};

export const formatPhoneNumber = (
  numberToFormat: string,
  countryCode: string = '',
  showCountryCode: boolean = false
) => {
  let formatted = cleanSubscriberNumber(numberToFormat);
  if (countryCode) {
    const country = getCountry(countryCode, formatted);
    formatted = formatIncompletePhoneNumber(
      showCountryCode ? countryCode + formatted : formatted,
      country
    );

    if (formatted.startsWith(countryCode)) {
      formatted = formatted.substring(countryCode.length).trim();
    }
  }
  return formatted;
};

export const convertToCallbackParameter = (codePart: string | undefined, numberPart: string) => {
  return [codePart, cleanSubscriberNumber(numberPart)].join('');
};

interface PhoneFormatOptions {
  nationalFormat?: boolean;
}

export const formatPhone = (value: string, { nationalFormat }: PhoneFormatOptions = {}) => {
  return nationalFormat
    ? parsePhoneNumber(value)?.formatNational()
    : parsePhoneNumber(value)?.formatInternational();
};

export default getPhoneNumberParts;
